import { render } from "./SideBar.vue?vue&type=template&id=8ec40450&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=8ec40450&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8ec40450"

export default script